import React, { useState } from 'react';
import { Sidebar } from './components/Sidebar';
import { TopBar } from './components/TopBar';
import { Dashboard } from './pages/Dashboard';
import { Products } from './pages/Products';
import { ProductDetail } from './pages/ProductDetail';
import { Competitors } from './pages/Competitors';
import { Alerts } from './pages/Alerts';
import { History } from './pages/History';
import { AnimatePresence } from 'framer-motion';
type Page = 'dashboard' | 'products' | 'product-detail' | 'competitors' | 'alerts' | 'history';
export function App() {
  const [currentPage, setCurrentPage] = useState<Page>('dashboard');
  const [selectedProductId, setSelectedProductId] = useState<number | null>(null);
  const handleProductClick = (id: number) => {
    setSelectedProductId(id);
    setCurrentPage('product-detail');
  };
  const handleBackToProducts = () => {
    setSelectedProductId(null);
    setCurrentPage('products');
  };
  const renderPage = () => {
    switch (currentPage) {
      case 'dashboard':
        return <Dashboard data-id="element-0" />;
      case 'products':
        return <Products onProductClick={handleProductClick} data-id="element-1" />;
      case 'product-detail':
        return selectedProductId ? <ProductDetail productId={selectedProductId} onBack={handleBackToProducts} data-id="element-2" /> : <Products onProductClick={handleProductClick} data-id="element-3" />;
      case 'competitors':
        return <Competitors data-id="element-4" />;
      case 'alerts':
        return <Alerts data-id="element-5" />;
      case 'history':
        return <History data-id="element-6" />;
      default:
        return <Dashboard data-id="element-7" />;
    }
  };
  // Map internal page state to sidebar active state
  const sidebarActivePage = currentPage === 'product-detail' ? 'products' : currentPage;
  return <div className="min-h-screen bg-[#F8F9FB] font-sans text-slate-800" data-id="element-8">
      <Sidebar currentPage={sidebarActivePage as any} setPage={page => setCurrentPage(page)} data-id="element-9" />

      <div className="ml-64 min-h-screen flex flex-col" data-id="element-10">
        <TopBar data-id="element-11" />

        <main className="flex-1 p-8 overflow-x-hidden" data-id="element-12">
          <AnimatePresence mode="wait" data-id="element-13">{renderPage()}</AnimatePresence>
        </main>
      </div>
    </div>;
}